import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react"; // for icons — install via: npm install lucide-react

export default function MainMenu() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div >
      <nav className="navbar abhmenu">
      {/* Header Bar */}
      <div className="navbar-header">
        <h2 className="logo">Abhedasramam</h2>

        {/* Hamburger Icon (Visible only on mobile) */}
        <button className="menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Menu Items */}
      <div className={`menu-container ${isMenuOpen ? "open" : ""}`}>
        <div className="boxes">
          <Link to="/" className="menuitems">
            Home
          </Link>
        </div>

        {/* Gurudev Submenu */}
        <div
          className="boxes submenu-container"
          onMouseEnter={() => setIsSubmenuOpen(true)}
          onMouseLeave={() => setIsSubmenuOpen(false)}
        >
          <p className="menuitems submenu-title">
            Gurudev ▾
          </p>
          {isSubmenuOpen && (
            <div className="submenu">
              <Link to="Gurudev" className="submenu-item">
                Gurudev
              </Link>
              <Link to="Arayoor" className="submenu-item">
                Arayoor
              </Link>
            </div>
          )}
        </div>

        <div className="boxes">
          <a
            href="https://booking.abhedasramam.org/"
            className="menuitems"
            target="_blank"
            rel="noopener noreferrer"
          >
            Online Booking
          </a>
        </div>

        <div className="boxes">
          <Link to="Timing" className="menuitems">
            Akhanda Nama Japam
          </Link>
        </div>

        <div className="boxes">
          <Link to="Gallery" className="menuitems">
            Gallery
          </Link>
        </div>

        <div className="boxes">
          <Link to="Emagazine" className="menuitems">
            e-Magazine
          </Link>
        </div>

        <div className="boxes">
          <Link to="Contact" className="menuitems">
            Contact
          </Link>
        </div>
      </div>
    </nav>
    </div>
    
  );
}
